exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_controller_1WeaPQlYZvy00gKiGJl6M9 {\n  width: 30px;\n  position: relative;\n  margin-left: -36px;\n  border: 1px solid #cccccc;\n  background: #f9f9f9;\n  float: left;\n  border-radius: 5px;\n}\n\n.IA_controllerButton_1IguNRqoN0mD9PXwJ4IAxU {\n  width: 40px;\n  height: 120px;\n  position: absolute;\n  left: -10px;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_controller": "IA_controller_1WeaPQlYZvy00gKiGJl6M9",
	"IA_controllerButton": "IA_controllerButton_1IguNRqoN0mD9PXwJ4IAxU"
};